/* eslint-disable consistent-return */
/* eslint-disable camelcase */
import axios from 'axios';

function getBaseURL() {
  const { protocol, hostname, port } = window.location;
  return process.env.NODE_ENV === 'production'
    ? `${protocol}//${hostname}${port ? `:${port}` : ''}/${process.env.VUE_APP_CONTEXT}`
    : process.env.VUE_APP_API;
}

const baseURL = getBaseURL();

const http = axios.create({
  baseURL,
  headers: {
    Authorization: 'Basic cnVzdGNvbnNlYzpydXN0Y29uc2Vj',
  },
});

function openUrls(url) {
  return url !== '/oauth/token';
}

const { protocol, host } = window.location;
const context = process.env.VUE_APP_CONTEXT || '';
const unauthorizedRedirectURL = `${protocol}//${host}/${context}`;

http.interceptors.request.use((config) => {
  const storage = localStorage.getItem('@sapitur/servidor-online');

  if (storage && openUrls(config.url)) {
    const { tokens } = JSON.parse(storage);

    if (tokens) {
      const { access_token } = tokens;

      if (access_token) {
        const updatedConfig = { ...config };
        updatedConfig.headers.Authorization = `Bearer ${access_token}`;
        updatedConfig.headers['Content-Type'] = 'application/json';
        return updatedConfig;
      }
    }
  }

  return config;
});

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config: originalRequest, status, data: errorData } = error.response;

    if (status === 401) {
      if (errorData.error_description) {
        const description = errorData.error_description;
        if (description === 'Bad credentials') {
          return Promise.reject(description);
        }
      }
    }

    if (status === 401 && originalRequest.retry) {
      window.localStorage.removeItem('@sapitur/servidor-online');
      window.location.assign(unauthorizedRedirectURL);
      return;
    }

    if (status === 401 && !originalRequest.retry) {
      originalRequest.retry = true;

      const storage = localStorage.getItem('@sapitur/servidor-online');

      if (!storage) {
        return Promise.reject(new Error('Sem credenciais para refresh'));
      }

      const localStorageData = JSON.parse(storage);
      const { tokens } = localStorageData;

      const form = new FormData();
      form.append('grant_type', 'refresh_token');
      form.append('refresh_token', tokens.refresh_token);

      try {
        const { data } = await axios.post(`${baseURL}/oauth/token`, form, {
          headers: {
            Authorization: 'Basic cnVzdGNvbnNlYzpydXN0Y29uc2Vj',
          },
        });
        localStorageData.tokens = data;
        localStorage.setItem('@sapitur/servidor-online', JSON.stringify(localStorageData));
        originalRequest.retry = false;
        return http.request(originalRequest);
      } catch (refreshError) {
        window.localStorage.removeItem('@sapitur/servidor-online');
        window.location.assign(unauthorizedRedirectURL);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default http;
